<ng-container *ngIf="callDetails$ | async as callDetails">
    <div class="ai-call-assist" [ngClass]="{ '--compact': compact }">
        <div class="ai-call-assist__header">
            <span class="ai-call-assist__pulse" [ngClass]="{ active: twilioService.isLineBusy }"></span>
            <strong>AI Assist</strong>
            <span class="ai-call-assist__status">{{ getStatusLabel(callDetails.aiAssist) }}</span>
        </div>

        <div class="ai-call-assist__compact" *ngIf="compact">
            <span class="ai-call-assist__intent text-capitalize">{{ getIntentLabel(callDetails.aiAssist?.intent) }}</span>
            <span *ngIf="getOrderCount(callDetails.orders) > 0">{{ getOrderCount(callDetails.orders) }} orders</span>
            <span class="ai-call-assist__reply">{{ getSuggestedReply(callDetails) }}</span>
        </div>

        <ng-container *ngIf="!compact">
            <div class="ai-call-assist__context">
                <ng-container *ngIf="twilioService.onLineContact$$ | async as contact; else unknownContact">
                    <div>
                        <small>Customer</small>
                        <strong>{{ contact.contactFirstname }} {{ contact.contactSurname }}</strong>
                    </div>
                    <div class="text-end">
                        <small>Type</small>
                        <strong class="text-capitalize">{{ contact.accountType || '-' }}</strong>
                    </div>
                </ng-container>
                <ng-template #unknownContact>
                    <div>
                        <small>Caller</small>
                        <strong>{{ twilioService.onLinePhoneNr$$ | async | formatPhone }}</strong>
                    </div>
                    <div class="text-end">
                        <small>Match</small>
                        <strong>Unknown</strong>
                    </div>
                </ng-template>
            </div>

            <div class="ai-call-assist__suggestion">
                <small>Suggestion</small>
                <p>{{ getSuggestedReply(callDetails) }}</p>
            </div>

            <div class="ai-call-assist__section" *ngIf="getTopOrders(callDetails.orders).length > 0">
                <small>Recent orders</small>
                <div class="ai-call-assist__order" *ngFor="let order of getTopOrders(callDetails.orders)">
                    <span>#ORD {{ order.publicId }}-{{ order.lineId }}</span>
                    <strong>{{ order.net | currency : 'GBP' }}</strong>
                </div>
            </div>

            <div class="ai-call-assist__section" *ngIf="getPriceMatches(callDetails.aiAssist).length > 0">
                <small>Price match</small>
                <div class="ai-call-assist__price" *ngFor="let match of getPriceMatches(callDetails.aiAssist)">
                    <span>{{ match.title }}</span>
                    <strong *ngIf="match.price !== undefined">{{ match.price | currency : 'GBP' }}{{ match.unit ? ' / ' + match.unit : '' }}</strong>
                </div>
            </div>

            <div class="ai-call-assist__section">
                <small>Transcript</small>
                <ng-container *ngIf="getTranscriptLines(callDetails.aiAssist).length > 0; else transcriptWaiting">
                    <div class="ai-call-assist__line" *ngFor="let line of getTranscriptLines(callDetails.aiAssist)">
                        <span class="text-capitalize">{{ line.speaker || 'system' }}</span>
                        <p>{{ line.text }}</p>
                    </div>
                </ng-container>
                <ng-template #transcriptWaiting>
                    <div class="ai-call-assist__empty">Waiting for transcript</div>
                </ng-template>
            </div>

            <div class="ai-call-assist__actions" *ngIf="callDetails.aiAssist?.actionCandidates?.length > 0">
                <span *ngFor="let action of callDetails.aiAssist.actionCandidates">{{ action.label }}</span>
            </div>
        </ng-container>
    </div>
</ng-container>
